module.exports = __webpack_public_path__ + "media/images/contact-d50ab0ad5e330fcab7ebfa3ae82f33c3.jpg";